"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentResourceTemplateSchema = void 0;
exports.ContentResourceTemplateSchema = {
    "$id": "https://www.redbull.com/schemas/templates/content-resource.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ContentResourceTemplate",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/apple-immersive-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-episodes.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/audio-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/author-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/collections.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/editorial-lists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/energy-drinks.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/episode-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-details.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/event-series.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/external-persons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/external-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/externals.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/films.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/image-galleries.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/images.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/immersive-3d-models.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/judges.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/live-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/locations.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/misc.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/occasion-campaigns.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/occasions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/onsite-promotions.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/partner-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/person-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/photographers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/playlists.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/preview-clips.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/project-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/rally-drivers.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/rally-teams.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/recap-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/results-standings.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/seasons.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/shows.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/stories.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/tags.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/team-profiles.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/trailer-videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/tv-commercials.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/tv-partner-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/video-3d.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/video-channels.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/videos.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/videos-360.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,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